import React from "react";
import "./Footer.style.scss";

const Footer = () => {
  return (
    <footer>
      <div className="footer-container text-center">
        <div className="brand__name">IQCio, LLC</div>
        <div className="brand__address">
          <p>90 Park Avenue, 5th Floor, New York, NY, 10016</p>
          <p>
            <a href="mailto:admin@iqcio.com">admin@iqcio.com</a>
          </p>
        </div>
        <div className="brand__menu">
          <ul>
            <li>
              <a href="#">Disclaimer</a>
            </li>
            <li>
              <a href="#">Privacy</a>
            </li>
            <li>
              <a href="#">Connect</a>
            </li>
          </ul>
        </div>
        <div className="brand__copyright">
          &copy; IQCIO LLC 2018-2020 All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.jsx